<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Proyecciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Tif</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Procesos</li>
                  <li class="breadcrumb-item active">Proyecciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-11"></div>
                  <div class="col-md-1">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn bg-navy shadow"
                        @click="getIndex()"
                      >
                        <i class="fas fa-sync-alt fa-spin"></i>
                      </button>
                      <button
                        type="button"
                        class="btn bg-gradient-primary ml-1 shadow"
                        @click="create()"
                        v-if="$store.getters.can('tif.proyecciones.create')"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body p-0">
                <table
                  class="table table-bordered table-striped table-hover table-sm"
                >
                  <thead>
                    <tr>
                      <th class="text-center">
                        Id
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          v-model="filtros.id"
                          @change="getIndex()"
                        />
                      </th>
                      <th class="text-center p-3">
                        Nombre
                      </th>
                      <th class="text-center">
                        Mes
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.mes"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="mes in listasForms.meses"
                            :key="mes.numeracion"
                            :value="mes.numeracion"
                          >
                            {{ mes.descripcion }}
                          </option>
                        </select>
                      </th>
                      <th class="text-center">
                        Año
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          v-model="filtros.ano"
                          @change="getIndex()"
                        />
                      </th>
                      <th class="text-center">
                        Bloque
                        <v-select
                          class="form-control form-control-sm p-0"
                          placeholder="Bloque"
                          label="nombre"
                          v-model="bloque"
                          :options="listasForms.bloques"
                          @input="selectBloque"
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                        >
                        </v-select>
                      </th>
                      <th class="text-center">
                        Estado
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </th>
                      <th class="text-center p-3">
                        Acción
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(proyeccion, index) in proyecciones.data"
                      :key="index"
                    >
                      <td class="text-center">{{ proyeccion.id }}</td>
                      <td class="text-center">{{ proyeccion.nombre }}</td>
                      <td class="text-center">{{ proyeccion.nMes }}</td>
                      <td class="text-center">{{ proyeccion.ano }}</td>
                      <td class="text-center">
                        <div
                          v-for="(bloques, indice) in proyeccion.bloques"
                          :key="indice"
                        >
                          <span class="badge bg-navy">
                            {{ bloques.nombre }}
                          </span>
                        </div>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="
                            proyeccion.estado == 1
                              ? 'badge-warning'
                              : 'badge-success'
                          "
                        >
                          {{ proyeccion.nEstado }}
                        </span>
                      </td>
                      <td class="text-center">
                        <div class="btn-group shadow">
                          <button
                            type="button"
                            class="btn btn-success"
                            @click="exportExcel(proyeccion.id)"
                            v-if="
                              $store.getters.can('tif.proyecciones.export') &&
                                proyeccion.estado == 2
                            "
                          >
                            <i class="far fa-file-excel"></i>
                          </button>
                          <button
                            type="button"
                            class="btn bg-gradient-navy btn-sm"
                            @click="edit(proyeccion)"
                            v-if="$store.getters.can('tif.proyecciones.edit')"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="proyecciones.total">
                  <p>
                    Mostrando del <b>{{ proyecciones.from }}</b> al
                    <b>{{ proyecciones.to }}</b> de un total:
                    <b>{{ proyecciones.total }}</b> Registros
                  </p>
                </div>
                <div class="float-left" v-else>
                  <p>
                    <span class="badge badge-danger">
                      No hay registros para mostrar
                    </span>
                  </p>
                </div>
                <pagination
                  :data="proyecciones"
                  @pagination-change-page="getIndex"
                  :limit="5"
                  align="right"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Loading from "../../../../components/Loading";
import vSelect from "vue-select";

export default {
  name: "TifProyeccionIndex",
  components: {
    pagination,
    Loading,
    vSelect,
  },
  data() {
    return {
      proyecciones: {},
      cargando: false,
      bloque: [],
      filtros: {
        id: null,
        bloque_id: null,
        mes: null,
        ano: null,
        estado: null,
      },
      listasForms: {
        estados: [],
        anos: [],
        meses: [],
        bloques: [],
      },
    };
  },
  methods: {
    getIndex(page = 1) {
      this.cargando = true;
      axios
        .get("/api/tif/proyecciones/index?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.cargando = false;
          this.proyecciones = response.data;
        });
    },

    getMes() {
      axios.get("/api/lista/152").then((response) => {
        this.listasForms.meses = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    getBloques() {
      axios.get("/api/admin/bloques/lista").then((response) => {
        this.listasForms.bloques = response.data;
      });
    },

    selectBloque() {
      this.filtros.bloque_id = null;
      if (this.bloque) {
        this.filtros.bloque_id = this.bloque.id;
      }
      this.getIndex();
    },

    create() {
      return this.$router.push({
        name: "/Tif/TifProyeccionForm",
        params: { accion: "Crear", id: 0 },
      });
    },

    edit(proyeccion) {
      return this.$router.push({
        name: "/Tif/TifProyeccionForm",
        params: {
          accion: "Editar",
          data_edit: proyeccion,
        },
      });
    },

    exportExcel(id) {
      const data = { id };
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/tif/proyecciones/excel",
        data,
      })
        .then((response) => {
          let data = response.data;
          location.href = data.url;
          this.cargando = false;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error - " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    destroy(proyeccion_id) {
      this.$swal({
        title: "Esta seguro de eliminar la proyección: " + proyeccion_id + "?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios
            .delete(
              "/api/hidrocarburos/proyeccionHidrocarburos/" + proyeccion_id
            )
            .then(() => {
              this.cargando = false;
              this.$swal({
                icon: "success",
                title: "Se eliminó la proyección exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              this.getIndex();
            });
        }
      });
    },
  },
  mounted() {
    this.getIndex();
    this.getEstados();
    this.getBloques();
    this.getMes();
  },
};
</script>
